export default class Navbar {
    static init(): void {
        this.navbarInit();
    }

    static navbarInit(): void {
        class MobileMenu {
            private toggle: HTMLElement | null;
            private menu: HTMLElement | null;
            private items: NodeListOf<HTMLElement>;
            private navbar: HTMLElement | null;
            private readonly breakpoint: number = 992;
            private readonly scrollThreshold: number = 90;
            private isFixed: boolean = false;

            constructor() {
                this.toggle = document.querySelector('.base-nav__toggle');
                this.menu = document.querySelector('.base-nav-mobile');
                this.items = document.querySelectorAll('.base-nav-mobile__item');
                this.navbar = document.querySelector('.base-nav');

                this.init();
            }

            private init(): void {
                if (!this.toggle || !this.menu) return;

                // Toggle menu při kliknutí
                this.toggle.addEventListener('click', () => this.toggleMenu());

                // Zavření menu při kliknutí na item
                this.items.forEach((item) => {
                    item.addEventListener('click', () => this.closeMenu());
                });

                // Zavření menu při resize nad breakpoint
                window.addEventListener('resize', () => this.handleResize());

                // Scroll handler
                window.addEventListener('scroll', () => this.handleScroll());
            }

            private toggleMenu(): void {
                this.toggle?.classList.toggle('is-active');
                this.menu?.classList.toggle('is-open');
            }

            private closeMenu(): void {
                this.toggle?.classList.remove('is-active');
                this.menu?.classList.remove('is-open');
            }

            private handleResize(): void {
                if (window.innerWidth > this.breakpoint) {
                    this.closeMenu();
                }
            }

            private handleScroll(): void {
                if (!this.navbar) return;

                const scrollPosition = window.scrollY;

                if (scrollPosition >= this.scrollThreshold && !this.isFixed) {
                    this.isFixed = true;
                    this.navbar.classList.add('is-fixed', 'not-top');
                    this.navbar.classList.remove('not-top');

                    setTimeout(() => {
                        this.navbar?.classList.add('not-top');
                    }, 10);
                } else if (scrollPosition < this.scrollThreshold && this.isFixed) {
                    this.isFixed = false;
                    this.navbar.classList.add('is-hiding');
                    this.navbar.classList.remove('not-top');

                    setTimeout(() => {
                        this.navbar?.classList.remove('is-fixed', 'is-hiding');
                    }, 250);
                }
            }
        }

        // Inicializace
        new MobileMenu();
    }
}
